<p style="padding-left: 32px; font-size: 18px;">Sarai riportato alla pagina del pagamento...</p>
